import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Workstream',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Workstream',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Absence',
                                  y: {
                                    '#': {
                                      '@': 'absence',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Absence',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Academic Staffing',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffing',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Academic Staffing',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Adaptive',
                                  y: {
                                    '#': {
                                      '@': 'adaptive',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Adaptive',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Banking & Setttlement',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlement',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Banking & Setttlement',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Benefits',
                                  y: {
                                    '#': {
                                      '@': 'benefits',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Benefits',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Business Assets',
                                  y: {
                                    '#': {
                                      '@': 'businessAssets',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Business Assets',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Compensation',
                                  y: {
                                    '#': {
                                      '@': 'compensation',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Compensation',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Core Financials/FDM',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdm',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Core Financials/FDM',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Cross-Functional',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctional',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Cross-Functional',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Customer Accounts',
                                  y: {
                                    '#': {
                                      '@': 'customerAccounts',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Customer Accounts',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data',
                                  y: {
                                    '#': {
                                      '@': 'data',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Data',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Effort Reporting',
                                  y: {
                                    '#': {
                                      '@': 'effortReporting',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Effort Reporting',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Financial Accounting',
                                  y: {
                                    '#': {
                                      '@': 'financialAccounting',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Financial Accounting',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'General',
                                  y: {
                                    '#': {
                                      '@': 'general',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'General',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Grants',
                                  y: {
                                    '#': {
                                      '@': 'grants',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Grants',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'HCM Core',
                                  y: {
                                    '#': {
                                      '@': 'hcmCore',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'HCM Core',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Integrations',
                                  y: {
                                    '#': {
                                      '@': 'integrations',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Integrations',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Inventory Management',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagement',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Inventory Management',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Learning',
                                  y: {
                                    '#': {
                                      '@': 'learning',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Learning',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll',
                                  y: {
                                    '#': {
                                      '@': 'payroll',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Payroll',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll Accounting',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccounting',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Payroll Accounting',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Procurement',
                                  y: {
                                    '#': {
                                      '@': 'procurement',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Procurement',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Recruiting',
                                  y: {
                                    '#': {
                                      '@': 'recruiting',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Recruiting',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting',
                                  y: {
                                    '#': {
                                      '@': 'reporting',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Reporting',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Supplier Accounts',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccounts',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Supplier Accounts',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Talent',
                                  y: {
                                    '#': {
                                      '@': 'talent',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream: 'Talent',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Time Tracking',
                                  y: {
                                    '#': {
                                      '@': 'timeTracking',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      workstream:
                                                        'Time Tracking',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Workstream',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    absence: {
      filter: {
        in: [
          'Absence',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffing: {
      filter: {
        in: [
          'Academic Staffing',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptive: {
      filter: {
        in: [
          'Adaptive',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlement: {
      filter: {
        in: [
          'Banking & Setttlement',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefits: {
      filter: {
        in: [
          'Benefits',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssets: {
      filter: {
        in: [
          'Business Assets',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensation: {
      filter: {
        in: [
          'Compensation',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdm: {
      filter: {
        in: [
          'Core Financials/FDM',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctional: {
      filter: {
        in: [
          'Cross-Functional',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccounts: {
      filter: {
        in: [
          'Customer Accounts',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    data: {
      filter: {
        in: [
          'Data',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReporting: {
      filter: {
        in: [
          'Effort Reporting',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccounting: {
      filter: {
        in: [
          'Financial Accounting',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    general: {
      filter: {
        in: [
          'General',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grants: {
      filter: {
        in: [
          'Grants',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCore: {
      filter: {
        in: [
          'HCM Core',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrations: {
      filter: {
        in: [
          'Integrations',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagement: {
      filter: {
        in: [
          'Inventory Management',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learning: {
      filter: {
        in: [
          'Learning',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payroll: {
      filter: {
        in: [
          'Payroll',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccounting: {
      filter: {
        in: [
          'Payroll Accounting',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurement: {
      filter: {
        in: [
          'Procurement',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruiting: {
      filter: {
        in: [
          'Recruiting',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reporting: {
      filter: {
        in: [
          'Reporting',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccounts: {
      filter: {
        in: [
          'Supplier Accounts',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talent: {
      filter: {
        in: [
          'Talent',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTracking: {
      filter: {
        in: [
          'Time Tracking',
          {
            '??': [
              {
                '@.': '!workstream',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
